import { required } from "vuelidate/lib/validators";

export default class ConfiguracaoValorDescontoData {
  id_faixa_revenda = "";

  percentual = 0;

  constructor({ id_faixa_revenda = "", percentual = 0 }) {
    this.id_faixa_revenda = id_faixa_revenda;
    this.percentual = percentual;
  }
}

export const ConfiguracaoValorDescontoDataRequired = {
  id_faixa_revenda: {
    required
  },
  percentual: {
    required
  }
};
